// externals
import { uniq } from 'lodash';

export const DEALER_REVIEW_FIELD_LABELS = {
    zipCode: 'Zip Code',
    tradeIn: 'Trade-In',
    vehicleOfInterest: 'Vehicle'
} as const;

export type KnownDealerReviewChangedField = keyof typeof DEALER_REVIEW_FIELD_LABELS;

export const humaniseChangedField = (rawFieldName: string): string => {
    const spaced = rawFieldName
        .replace(/[_-]+/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim();

    if (!spaced) {
        return rawFieldName;
    }

    return spaced
        .split(' ')
        .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
        .join(' ');
};

const isKnownChangedField = (fieldName: string): fieldName is KnownDealerReviewChangedField =>
    Object.prototype.hasOwnProperty.call(DEALER_REVIEW_FIELD_LABELS, fieldName);

// Unknown names are humanised rather than dropped, so Sales Check-In can add fields without an MV release.
export const getChangedFieldLabel = (rawFieldName: string): string =>
    isKnownChangedField(rawFieldName) ? DEALER_REVIEW_FIELD_LABELS[rawFieldName] : humaniseChangedField(rawFieldName);

export const getChangedFieldLabels = (changedFields: string[] | undefined): string[] =>
    uniq((changedFields ?? []).map(getChangedFieldLabel).filter((label) => label.trim().length > 0));
